import type { PeEnrollmentYear } from '../../types';

export interface EnrollmentBarRow {
  schoolYear: string;
  elCount: number;
  newcomerCount: number | null;
  newlyIdentified: number | null;
  exited: number | null;
  continuing: number | null;
}

export function buildEnrollmentBarData(years: PeEnrollmentYear[]): EnrollmentBarRow[] {
  return [...years]
    .sort((a, b) => a.school_year.localeCompare(b.school_year))
    .map((year) => {
      const splitKnown = year.newly_identified_count != null && year.exited_count != null;
      const newlyIdentified = splitKnown ? (year.newly_identified_count ?? null) : null;
      const exited = splitKnown ? (year.exited_count ?? null) : null;
      const continuing =
        newlyIdentified === null || exited === null
          ? null
          : Math.max(0, year.el_count - newlyIdentified - exited);
      return {
        schoolYear: year.school_year,
        elCount: year.el_count,
        newcomerCount: year.newcomer_count,
        newlyIdentified,
        exited,
        continuing,
      };
    });
}
